import { call, put, takeEvery, takeLatest, delay } from "redux-saga/effects"
import { CREATE_GATEPASS_APPROVAL, CREATE_GATEPASS_APPROVER, GET_ALL_APPROVAL_STAFF, GET_ALL_GATEPASS_REQUEST, GET_ALL_STAFF, GET_GATEPASS_REPORT, GET_STAFF_BY_STAFFTYPE, GET_STAFF_TYPES, GET_TEACHER_GATEPASS_REPORT, UPDATE_ADMIN_GATEPASS_REQUEST, UPDATE_GATEPASS_REQUEST } from "./constants";

const { getStaffTypesSuccess, getStaffTypesFailed, getStaffByStaffTypeSuccess, getStaffByStaffTypeFailed, createGatePassApproverSuccess, createGatePassApproverFailed, getAllApprovalStaffSuccess, getAllApprovalStaffFailed, getAllGatePassRequestSuccess, getAllGatePassRequestFailed, updateGatePassRequestSuccess, updateGatePassRequestFailed, updateAdminGatePassRequestSuccess, updateAdminGatePassRequestFailed, getTeacherGatePassReportSuccess, getTeacherGatePassReportFailed, createGatePassApprovalSuccess, createGatePassApprovalFailed, getGatePassReportSuccess, getGatePassReportFailed, getAllStaffSuccess, getAllStaffFailed } = require("./actions");
const { getStaffTypesApi, getStaffBystaffTypeApi, createGatePassApproverApi, getAllApprovalStaffApi, getAllGatePassRequestApi, updateGatePassRequestAPI, updateAdminGatePassRequestApi, getTeacherGatePassReportApi, createGatePassApprovalAPI, getGatePassReportAPI, getAllStaffAPI } = require("./api");

function* getStaffTypesAsync(action) {

    try {
        const response = yield call(getStaffTypesApi)
        // console.log(response.data.data)
        if (response) {
            yield put(getStaffTypesSuccess(response?.data?.data || []))
        } else {
            throw response;
        }

    } catch (error) {
        console.log("error", error)
        yield put(getStaffTypesFailed(error?.response?.message || "Unable to get Staff Type"))
    }
}


function* getStaffByStaffTypeAsync(action) {

    try {
        const response = yield call(getStaffBystaffTypeApi, action.payload)
        if (response) {
            yield put(getStaffByStaffTypeSuccess(response?.data?.data || []))
        } else {
            throw response;
        }

    } catch (error) {
        console.log("error", error)
        yield put(getStaffByStaffTypeFailed(error?.response?.message || "Unable to get Staff Type"))
    }
}


function* createGatePassApproverAsync(action) {

    try {
        const response = yield call(createGatePassApproverApi, action.payload)
        if (response) {
            yield put(createGatePassApproverSuccess(response?.data?.data || "New Gate Pass Approver Created !"))
        } else {
            throw response;
        }

    } catch (error) {
        console.log("error", error)
        yield put(createGatePassApproverFailed(error?.response?.message || "Unable to Create Gate Pass, Pleaese try again"))
    }
}

function* getAllApprovalStaffAsync(action) {

    try {
        const response = yield call(getAllApprovalStaffApi, action.payload)
        if (response) {
            yield put(getAllApprovalStaffSuccess(response?.data?.data || "New Gate Pass Approver Created !"))
        } else {
            throw response;
        }

    } catch (error) {
        console.log("error", error)
        yield put(getAllApprovalStaffFailed(error?.response?.message || "Unable to Get Gate Pass Approval Staff, Pleaese try again"))
    }
}


function* getAllGatePassRequestAsync() {

    try {
        const response = yield call(getAllGatePassRequestApi)
        if (response) {
            yield put(getAllGatePassRequestSuccess(response?.data?.data || []))
        } else {
            throw response;
        }

    } catch (error) {
        console.log("error", error)
        yield put(getAllGatePassRequestFailed(error?.response?.message || "Unable to Get Gate Pass Requests, Pleaese try again"))
    }
}


function* updateGatePassRequestAsync(action) {

    try {
        const response = yield call(updateGatePassRequestAPI, action.payload)
        if (response) {
            yield put(updateGatePassRequestSuccess(response?.data?.data || "Updated Successfully"))
        } else {
            throw response;
        }

    } catch (error) {
        console.log("error", error)
        yield put(updateGatePassRequestFailed(error?.response?.data || "Unable to Update Gate Pass Requests, Pleaese try again"))
    }
}


function* updateAdminGatePassRequestAsync(action) {

    try {
        const response = yield call(updateAdminGatePassRequestApi, action.payload)
        if (response) {
            yield put(updateAdminGatePassRequestSuccess(response?.data?.data || "Updated Successfully !"))
        } else {
            throw response;
        }

    } catch (error) {
        console.log("error", error)
        yield put(updateAdminGatePassRequestFailed(error?.response?.data || "Unable to Update Gate Pass Requests, Pleaese try again"))
    }
}


function* getTeacherGatePassReportAsync() {

    try {
        const response = yield call(getTeacherGatePassReportApi)
        if (response) {
            yield put(getTeacherGatePassReportSuccess(response?.data?.data || []))
        } else {
            throw response;
        }

    } catch (error) {
        console.log("error", error)
        yield put(getTeacherGatePassReportFailed(error?.response?.data || "Unable to Get Gate Pass Report, Pleaese try again"))
    }
}


function* createGatePassApprovalAsync(action) {

    try {
        const response = yield call(createGatePassApprovalAPI, action.payload)
        if (response) {
            yield put(createGatePassApprovalSuccess(response?.data?.data || "Gate Pass Approval Created Successfully !"))
        } else {
            throw response;
        }

    } catch (error) {
        console.log("error", error)
        yield put(createGatePassApprovalFailed(error?.response?.data || "Unable to Create Gate Pass Approval, Please try again"))
    }
}




function* getGatePassReportAsync(action) {

    try {
        const response = yield call(getGatePassReportAPI, action.payload)
        if (response) {
            yield put(getGatePassReportSuccess(response?.data?.data || []))
        } else {
            throw response;
        }

    } catch (error) {
        console.log("error", error)
        yield put(getGatePassReportFailed(error?.response?.data || "Unable to Get Gate Pass Report, Please try again"))
    }
}


function* getAllStaffAsync() {

    try {
        const response = yield call(getAllStaffAPI)
        if (response) {
            yield put(getAllStaffSuccess(response?.data || []))
        } else {
            throw response;
        }

    } catch (error) {
        console.log("error", error)
        yield put(getAllStaffFailed(error?.response?.data || "Unable to Get Gate Pass Report, Please try again"))
    }
}

function* gatePassSaga() {

    yield takeEvery(GET_STAFF_TYPES, getStaffTypesAsync)
    yield takeEvery(GET_STAFF_BY_STAFFTYPE, getStaffByStaffTypeAsync)
    yield takeEvery(CREATE_GATEPASS_APPROVER, createGatePassApproverAsync)
    yield takeEvery(GET_ALL_APPROVAL_STAFF, getAllApprovalStaffAsync)
    yield takeEvery(GET_ALL_GATEPASS_REQUEST, getAllGatePassRequestAsync)
    yield takeEvery(UPDATE_GATEPASS_REQUEST, updateGatePassRequestAsync)
    yield takeEvery(UPDATE_ADMIN_GATEPASS_REQUEST, updateAdminGatePassRequestAsync)
    yield takeEvery(GET_TEACHER_GATEPASS_REPORT, getTeacherGatePassReportAsync)
    yield takeEvery(CREATE_GATEPASS_APPROVAL, createGatePassApprovalAsync)
    yield takeEvery(GET_GATEPASS_REPORT, getGatePassReportAsync)
    yield takeEvery(GET_ALL_STAFF, getAllStaffAsync)

}

export default gatePassSaga;